var render = function render(){var _vm=this,_c=_vm._self._c;return (this.objFAQ)?_c('div',{staticClass:"ReCardTicketFaq"},[_c('div',{staticClass:"d-flex"},[_c('router-link',{attrs:{"to":'/data/ticketsystem/faq/id/'+_vm.objFAQ.id}},[_vm._v(_vm._s(_vm.objFAQ.name))])],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }